import React, { createContext, useMemo, useContext, useState } from 'react'
import { User } from 'oidc-client-ts'

import { IGlobalProvider, IHeaderInfo } from './IGlobalProvider.d'

const GlobalContext = createContext(null)

interface GlobalProviderProps {
  children: React.ReactNode;
  initData: Record<string, unknown>;
}

const GlobalProvider = ({ children, initData }: GlobalProviderProps) => {
  // "solicitud" when dashboard steps are complete and sent
  const [isRequestSent, setIsRequestSent] = useState<boolean>(false)
  const [showCollaboratorsModal, setShowCollaboratorsModal] = useState<boolean>(false)
  const [userProfile, setUserProfile] = useState<User>(null)
  const [idEmpresa, setIdEmpresa] = useState<string>('')
  const [idSuscriptor, setIdSuscriptor] = useState<string>('')
  const [companyQuantity, setCompanyQuantity] = useState<number>(0)
  const [lastModifiedDate, setLastModifiedDate] = useState<string>('')
  const [cuit, setCuit] = React.useState<string>('')
  const [companyName, setCompanyName] = React.useState<string>('')

  const initHeader = {
    title: '',  
    subtitle: ''
  }

  const resetStates = () => {
    setIdEmpresa('')
    setCuit('')
    setCompanyName('')
    setIsRequestSent(false)
    setShowCollaboratorsModal(false)
  }

  const [headerInfo, setHeaderInfo] = useState<IHeaderInfo>(initHeader)

  const store = useMemo(() => ({
    initData,
    headerInfo,
    setHeaderInfo,
    idEmpresa,
    setIdEmpresa,
    idSuscriptor,
    setIdSuscriptor,
    isRequestSent,
    setIsRequestSent,
    cuit,
    setCuit,
    userProfile,
    setUserProfile,
    resetStates,
    companyQuantity,
    setCompanyQuantity,
    lastModifiedDate,
    setLastModifiedDate,
    companyName,
    setCompanyName,
    setShowCollaboratorsModal,
    showCollaboratorsModal,
  }), [initData, headerInfo, idEmpresa, idSuscriptor, cuit, userProfile, isRequestSent, companyQuantity, lastModifiedDate, companyName, showCollaboratorsModal])

  return (
    <GlobalContext.Provider value={store}>{children}</GlobalContext.Provider>
  )
}

const useGlobalContext = () => {
  const context: IGlobalProvider = useContext(GlobalContext)
  if (context === undefined) {
    throw new Error('GlobalContext must be used within a GlobalProvider')
  }
  return context
}

export { GlobalProvider, useGlobalContext }
